'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('./lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _promise = require('./promise');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var api = {
  /*
    Traverse through the schema and create the API function
  */
  insert: function insert(schema, ctx, options) {
    var _this = this;

    _lodash2.default.each(_lodash2.default.keys(schema), function (item) {
      _this.createResource(item, schema[item], ctx, options);
    });
  },


  /*
    Create the API function
    This changes endpoint definition from this getCategory: { path: 'categories/:id/posts.json' } to
    getCategory({ id: '1wpp' })
     The method created will return Object of response or error so that it can be access immediately
  */
  createResource: function createResource(key, schema, ctx, options) {
    ctx[key] = function () {
      // assign arguments
      var params = this.getPathParams(schema).length > 0 ? arguments[0] : null;
      var apiOpts = this.getPathParams(schema).length > 0 ? arguments[1] : arguments[0];
      return this.createPromise(key, schema, params, options, apiOpts);
    }.bind(this);
  },


  /*
    Get parameters from a given path. Given a path that looks like 'categories/:id/posts.json', it will return [:id]
     @return Array
  */
  getPathParams: function getPathParams(json) {
    var path = json.path;
    var parameters = path.match(/:\w+/g) || [];

    return parameters;
  },


  /*
    Transform the given path in the schema
    This changes schema path from /categories/:id/posts.json to /categories/1wpp/posts.json
     @return String
            Error - if path params is not correctly provided
  */
  transformPath: function transformPath(json, params, key) {
    var path = json.path;
    var parameters = this.getPathParams(json);
    var missingPath = [];
    var paramKey = void 0;

    if (params) {
      parameters.forEach(function (param) {
        paramKey = param.substring(1);

        if (params[paramKey]) {
          path = _lodash2.default.replace(path, param, params[paramKey]);
        } else {
          missingPath.push(paramKey);
        }
      });
    }

    if (missingPath.length > 0) {
      throw new Error('Missing path parameters for the endpoint ' + key + '. The missing path parameters are: ' + missingPath.join(', '));
    } else {
      return path;
    }
  },


  /*
    Create promise to do the API call using the correct path
    We use Axios for our Promise interface
     @return Promise
            Boolean - if error present
  */
  createPromise: function createPromise(key, json, params, options, apiOpts) {
    if (this.transformPath(json, params, key)) {
      var path = options.apiEndpoint + '/' + this.transformPath(json, params, key);
      var timeout = options.timeout;
      var headers = options.headers;
      var promise = this.request(path, {
        timeout: timeout,
        headers: headers,
        method: 'get',
        params: Object.assign({}, json.params, apiOpts)
      });

      return (0, _promise.cancellablePromise)(promise);
    }

    return false;
  },


  /*
    Create Promise-based API using Axios
     @return Promise
  */
  request: function request(url, params, opt) {
    var timeout = params.timeout;
    var headers = params.headers;
    var path = opt ? opt.apiEndpoint + '/' + url : url;
    var method = params.method ? params.method : 'get';
    return _axios2.default.create({ timeout: timeout, headers: headers })[method](path, { params: params.params });
  }
}; /*
     Construct API methods based on the schema given.
     A scheme that is written like this:
     getCategory: { path: 'categories/:id/posts.json' } can be access by the library instance like this:
   
     soompi.getCategory({ id: '1wpp' }, { perPage: 10, page: 1 }).then((response) => {
       return response
     })
   */

exports.default = api;


// WEBPACK FOOTER //
// ./submodules/soompi-js/dist/node/api.js